import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e7089fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row justify-center q-mt-xl" }
const _hoisted_2 = {
  class: "row justify-end",
  style: {"width":"100%"}
}
const _hoisted_3 = {
  class: "bg-primary self-end q-px-lg text-white text-bold row justify-center gt-sm",
  style: {"position":"relative","width":"150px"}
}
const _hoisted_4 = {
  class: "row",
  style: {"width":"100%"}
}
const _hoisted_5 = { class: "row col-xs-7 col-sm-7 col-md-5 col-lg-5 col-xl-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "primary-underlined col" }, null, -1))
const _hoisted_7 = {
  class: "row justify-center",
  style: {"width":"100%"}
}
const _hoisted_8 = { class: "row justify-between col-xs-7 col-sm-7 col-md-5 col-lg-5 col-xl-5" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.step) + " / " + _toDisplayString(_ctx.images.length), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.step >= 1 ? 'secondary-underlined' : 'primary-underlined', "col"])
      }, null, 2),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(_ctx.images.length - 1).keys(), (index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass((_ctx.step > index + 1 ? 'secondary-underlined' : 'primary-underlined') + (' col-' + _ctx.getColSize()))
          }, null, 2))
        }), 128))
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "responsive-img-div",
            onClick: ($event: any) => (_ctx.changeTabWizard(index + 1))
          }, [
            (_ctx.step >= index + 1)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "responsive-img",
                  src: require('../../assets/' + image.alt)
                }, null, 8, _hoisted_10))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "responsive-img",
                  src: require('../../assets/' + image.src)
                }, null, 8, _hoisted_11))
          ], 8, _hoisted_9))
        }), 128))
      ])
    ])
  ]))
}